import { AutogenLayoutOfficePayAdjustmentHistory } from "./autogen/AutogenLayoutOfficePayAdjustmentHistory";
import { DataSourceAction, DataSourceExecutionEvent, DataSourceMode, ClickEvent } from "@mcleod/components";
import { CurrencySettings, LogManager, Navigation } from "@mcleod/core";
import { getPayrollControlBoolean, getPayrollControlValue } from "@mcleod/general";

const log = LogManager.getLogger("lme.settlement.officepayroll.OfficePayAdjustmentHistory");

export class OfficePayAdjustmentHistory extends AutogenLayoutOfficePayAdjustmentHistory {

    override async onLoad(): Promise<void> {
        // Multi-currency visibility for source currency panel, if present
        if (this.panelSourceCurrency) {
            this.panelSourceCurrency.visible = CurrencySettings.getSingleton().multiCurrencyEnabled();
        }

        this.sourceOffDeductHist.addAfterExecutionListener((event: DataSourceExecutionEvent) => {
            if (event.getAction() === DataSourceAction.SEARCH) {
                this.setTitle();
                this.buttonViewCommissionsHistory.visible = getPayrollControlBoolean("enable_commissions");
                this.buttonViewCommissionsHistory.enabled = this.activeRow.get("accrual_module") === "SET";
            }
        });
        this.layoutGLDistribution.replaceMainDatasource(this.sourceJournalOffice);
        this.layoutGLDistribution.tableGLDistribution.removeColumn("columnHeaderOrderNumber");
    }

    protected setTitle() {
        if (this.mainDataSource.mode === DataSourceMode.ADD || this.mainDataSource.mode === DataSourceMode.SEARCH) {
            return;
        }
        const payeeData = this.mainDataSource.activeRow?.getLookupModelData("payee_id");
        const payee = payeeData && payeeData[0] ? " - " + payeeData[0].get("name") : "";
        this.dataHeader.title = this.titleSingular + payee;
    }

    /** This is an event handler for the onClick event of buttonViewCommissionsHistory. */
    buttonViewCommissionsHistoryOnClick(event: ClickEvent) {
        Navigation.navigateTo("lme/settlement/commissions/CommissionsHistoryList?postKey=" + this.activeRow.get("accrual_key"), { newTab: true });
    }
}
